import AppStateStore from './app-state-store';
import OrganizationStore from './organization-store';
import BackgroundCheckStore from './background-check-store';
import ApolloClient from '../core/apollo-client';

export class Stores {
  appStateStore = new AppStateStore(ApolloClient);
  organizationStore = new OrganizationStore();
  backgroundCheckStore = new BackgroundCheckStore(this.organizationStore);

  init = async () => {
    try {
      return await this.appStateStore.init();
    } catch (e) {
      console.log('Error initializing stores', e);
      return false;
    }
  };
}

export default new Stores();
